// @flow
import React from 'react';
import Flex from '@waglabs/flex';
import Text from '@waglabs/text';
import Icon from '@waglabs/icon';
import Link from '@waglabs/link';

import SocialMediaIcons from './components/SocialMediaIcons';

import {
  URL_IOS_APP_DOWNLOAD,
  URL_ANDROID_APP_DOWNLOAD,
} from '../../../../constants/routes.constants';

export const AppDownloadBlock = () => (
  <Flex
    justifyContent="center"
    alignItems="center"
    flexDirection="column"
    width={[1, 1, 'auto', 'auto']}
    boxsizing="border-box"
    pt={[0, 0, 0, 5]}
  >
    <Flex
      bg="backgroundGray"
      height={[260, 260, 260, 340]}
      width={[1, 1, 350, 530]}
      maxWidth={['80%', '68%', '100%']}
      flexDirection="column"
      borderRadius="25px"
      justifyContent="center"
      alignItems="center"
      boxsizing="border-box"
      px={[2]}
      mt={[0, 3]}
    >
      <Icon
        name="wagTextLogo"
        mb={3}
        width={[100, 120, 140, 200]}
      />
      <Flex
        mb={3}
        justifyContent="center"
        width={1}
      >
        <Link
          href={URL_ANDROID_APP_DOWNLOAD}
          target="_blank"
          width={1}
          mr={2}
        >
          <Icon
            name="googlePlay"
            mr={1}
            width={1}
            hover
          />
        </Link>
        <Link
          href={URL_IOS_APP_DOWNLOAD}
          target="_blank"
          width={1}
        >
          <Icon
            name="appStore"
            width={1}
            hover
          />
        </Link>
      </Flex>
      <Text
        m={0}
        color="medGray"
        fontFamily="body"
        fontSize={[2, 2, 2, 3]}
      >
        Download the Wag! App
      </Text>
    </Flex>
    <SocialMediaIcons
      iconWidth={['auto', 'auto', 'auto', 50]}
    />
  </Flex>
);
